<template>
  <div id="members-home">
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="200"
        aspect-ratio=1.5
        position="bottom 45% left"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      />
    </v-card>
    <v-container fluid>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        
            <v-flex>
              <v-list>
                <v-list-tile 
                  v-for="item in memberList"
                  :key="item.name"
                  avatar
                >
                  <!-- AVATAR -->
                  <v-list-tile-avatar>
                    <v-avatar color="primary">
                      <span class="white--text">{{ item.avatar }}</span>
                    </v-avatar>
                  </v-list-tile-avatar>
                  <!-- NAME -->
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.name"></v-list-tile-title>
                    <v-list-tile-sub-title v-text="item.role"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <!-- <v-list-tile>
                  <v-list-tile-sub-title class="text-xs-right"><i>TIP: right click on an image and select 'Open image in new tab' to view the full version</i></v-list-tile-sub-title>
                </v-list-tile> -->
              </v-list>
            </v-flex>
          
      </v-flex>
    </v-layout>
</v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      titleImg: 'https://images.unsplash.com/photo-1531398574919-7ebcf655bb4c?ixlib=rb-0.3.5&s=0db536f61b805cf169e37756ae4ee1b4&auto=format&fit=crop&w=1350&q=80',
      memberList: [
        {
          name: 'Joey Brown',
          // avatar: 'https://media.licdn.com/dms/image/C5603AQEOhD5eordiyw/profile-displayphoto-shrink_200_200/0?e=1544659200&v=beta&t=5PFwaPEw8El4mfuSqIThQTrmg_kcO0gOMT9sRlGsPc8',
          avatar: 'JB',
          role: 'Founder & CEO'
        },
        {
          name: 'Derrick Brown',
          // avatar: 'https://scontent-ort2-1.xx.fbcdn.net/v/t1.0-9/1909646_152402516282_3606870_n.jpg?_nc_cat=111&oh=50b0d517944a8b69303101552814ec2a&oe=5C4616E3',
          avatar: 'DB',
          role: 'CTO'
        },        
        {
          name: 'Will Schulz',
          // avatar: 'https://media.licdn.com/dms/image/C5603AQFrGJSV7vsGow/profile-displayphoto-shrink_800_800/0?e=1544659200&v=beta&t=S98nA0tUh_cYKV7UC_ZWBPdKMjIxiZtd_HAmhbyzFp8',
          avatar: 'WS',
          role: 'CFO'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/team/Members.vue